// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__103CV","footer":"ModalCreateQualiphyProcedure_footer__1R6Xx","additionData":"ModalCreateQualiphyProcedure_additionData__2i3Db"};